import { Injectable } from '@angular/core';
import { getStoredValue, removeStoredValue, setStoredValue } from '@clinic-platform/shared-types';

@Injectable({
  providedIn: 'root'
})
export class TokenStorageService
{
  private readonly accessTokenKey = 'clinic_access_token';

  public getAccessToken(): string | null
  {
    return getStoredValue(this.accessTokenKey);
  }

  public setAccessToken(token: string): void
  {
    setStoredValue(this.accessTokenKey, token);
  }

  public clear(): void
  {
    removeStoredValue(this.accessTokenKey);
  }
}
